import React from 'react';
import { Box, Paper, Typography, useTheme, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AgentChat from '../agent/components/AgentChat';
import AgentTaskList from '../agent/components/AgentTaskList';
import HomeIcon from '@mui/icons-material/Home';
import LogoutIcon from '@mui/icons-material/Logout';
import ThemeBackground from '../components/Layout/ThemeBackground';

const Agent: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { logout } = useAuth();

  const handleHome = () => {
    navigate('/home');
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <ThemeBackground variant="full">
      <div className="container mx-auto px-6 py-8 overflow-y-scroll">
        <div className="glass-card p-6 min-h-[calc(100vh-4rem)]">
          {/* Header with buttons */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: theme.spacing(2),
              marginBottom: theme.spacing(3)
            }}
          >
        <Button
          variant="contained"
          startIcon={<HomeIcon />}
          onClick={handleHome}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          Home Page
        </Button>
        <Button
          variant="contained"
          startIcon={<LogoutIcon />}
          onClick={handleLogout}
          sx={{
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          }}
        >
          Logout
        </Button>
          </Box>

          {/* Main content */}
          <Box
            sx={{
              display: 'flex',
              flex: 1,
              gap: theme.spacing(2),
              minHeight: '600px'
            }}
          >
        {/* Main Chat Area */}
        <Box
          sx={{
            flex: 2,
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0 // Allows flex child to shrink below content size
          }}
        >
          <Paper
            elevation={2}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'hidden',
              padding: theme.spacing(2)
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: theme.palette.primary.main,
                marginBottom: theme.spacing(2)
              }}
            >
              Agent Assistant
            </Typography>
            <AgentChat />
          </Paper>
        </Box>

        {/* Task List Sidebar */}
        <Paper
          elevation={2}
          sx={{
            width: '300px',
            padding: theme.spacing(2),
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: theme.palette.primary.main,
              marginBottom: theme.spacing(2)
            }}
          >
            Tasks
          </Typography>
          <AgentTaskList />
          </Paper>
        </Box>
      </div>
    </div>
    </ThemeBackground>
  );
};

export default Agent;
